import { elApp, elWebsite } from './strings';

const el = {
  translation: {
    ...elApp,
    ...elWebsite
  }
};

export default el;
